<div class="entity-border"
  [ngClass]="{'dead' : entity.dead, 'off' : !entity.dormant && entity.off, 'dormant' : entity.dormant, 'revealed' : !entity.dormant && entity.revealed && settingsManager.settings.scenarioRooms, 'revealed-active' : figure.active && !entity.dormant && entity.revealed && settingsManager.settings.scenarioRooms && settingsManager.settings.activeStandees, 'active' : !entity.dormant && (gameManager.isMonsterEntity(entity) && entity.active && settingsManager.settings.activeStandees || gameManager.isSummon(entity) && entity.active && settingsManager.settings.activeSummons), 'active-focus': !entity.dormant && entity.active && settingsManager.settings.activeStandees && !figure.active,'monster' : gameManager.isMonsterEntity(entity), 'objective' : gameManager.isObjectiveEntity(entity), 'summon' : gameManager.isSummon(entity), 'denied' : gameManager.isMonster(figure) && !gameManager.stateManager.monsterPermissions[figure.name + '|' + figure.edition] || gameManager.isObjectiveContainer(figure) && gameManager.stateManager.permissions && !gameManager.stateManager.permissions.characters ||  gameManager.isCharacter(figure) && !gameManager.stateManager.characterPermissions[figure.name + '|' + figure.edition], 'action-hint-border' : actionHints.length > 0 && (actionHints.length % 2) == 1 && activeConditions.length ==  0 && (gameManager.isObjectiveEntity(entity) && gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).summon == SummonState.false || gameManager.isSummon(entity) && gameManager.toSummon(entity).state == SummonState.false),  'fh': settingsManager.settings.theme == 'fh', 'modern': settingsManager.settings.theme == 'modern'}"
  [entityAnimation]="entity.dead">
  <div class="entity" [ngClass]="gameManager.isMonsterEntity(entity) ? gameManager.toMonsterEntity(entity).type : ''">
    <div #standee class="standee"
      [ngClass]="{'monster-standee' : gameManager.isMonsterEntity(entity), 'objective-standee' : gameManager.isObjectiveEntity(entity), 'summon-standee' : gameManager.isSummon(entity), 'bb-elite': gameManager.isMonster(figure) && gameManager.toMonster(figure).bb &&  gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).type == MonsterType.elite}">

      @if (gameManager.isSummon(entity) && gameManager.toSummon(entity).active) {
      <div class="sheet">
        <ghs-summon-sheet [summon]="gameManager.toSummon(entity)"></ghs-summon-sheet>
      </div>
      }

      <div class="background-image-container">
        @if (gameManager.isMonsterEntity(entity)) {
        <div class="background-image"
          [style.background-image]="figure.noThumbnail || !settingsManager.settings.artwork || !gameManager.isMonster(figure) ? '': 'url(' + gameManager.monsterManager.monsterThumbnail(gameManager.toMonster(figure)) + ')'">
        </div>
        }
        @if (gameManager.isSummon(entity) && settingsManager.settings.artwork && (gameManager.toSummon(entity).thumbnail
        && !gameManager.toSummon(entity).noThumbnail || gameManager.toSummon(entity).thumbnailUrl)) {
        <div class="background-image"
          [style.background-image]="gameManager.toSummon(entity).thumbnailUrl ? 'url(' +  gameManager.toSummon(entity).thumbnailUrl + ')' : 'url(./assets/images/summons/thumbnail/' + gameManager.toSummon(entity).thumbnail + '.png)'">
        </div>
        }
      </div>
      <span class="number"
        [ngClass]="(gameManager.isMonster(figure) && gameManager.toMonster(figure).bb ? 'bb-' + entity.number : '') + (entity.number < 1 && settingsManager.settings.animations ? ' highlight' : '')">
        <span class="value">{{entity.number < 0 ? '?' : entity.number}}</span>
        </span>

        @if (gameManager.isSummon(entity)) {
        <span class="summon-state"
          [ngClass]="{'active' : gameManager.toSummon(entity).state == SummonState.true, 'new' : gameManager.toSummon(entity).state == SummonState.new, 'center' : (gameManager.toSummon(entity).entityConditions.length % 2) == 0,  'fh': gameManager.toSummon(entity).color == SummonColor.fh,}">
          @if (gameManager.toSummon(entity).color != SummonColor.fh) {
          <img src="./assets/images/summons/{{gameManager.toSummon(entity).color}}.png">
          }
          <span class="summon-number">
            @if (gameManager.toSummon(entity).number == 0) {
            <span>-</span>
            }
            @if (gameManager.toSummon(entity).number > 0) {
            <span>{{gameManager.toSummon(entity).number}}</span>
            }</span>
        </span>
        }


        <span class="health" [ghs-label]="'game.health'" [ghs-label-attribute]="'title'"
          [ngClass]="{'damage' : settingsManager.settings.damageHP || objectiveData && objectiveData.trackDamage}">
          @if (maxHp && !settingsManager.settings.damageHP) {
          <span>
            {{((entity.health + health) | ghsMinZero)}}
          </span>
          }
          @if (maxHp && settingsManager.settings.damageHP) {
          <span>
            {{maxHp}}/{{((maxHp - entity.health + health) | ghsMinZero)}}
          </span>
          }
          @if (objectiveData && objectiveData.trackDamage) {
          <span>
            {{(entity.health + health) | ghsMinZero}}
          </span>
          }
          @if ((!objectiveData || !objectiveData.trackDamage) && !maxHp) {
          <span>-</span>
          }
        </span>
    </div>

    @if (!specialActionsMarker.length || specialActionsMarker.indexOf('mode') == -1) {
    <div class="conditions actions">
      @for (actionHint of actionHints | trackUUID; track actionHint._trackUUID; let i = $index) {
      <span class="condition-container"
        [ngClass]="{'center' : (actionHints.length % 2) == 1 && i == actionHints.length - 1}">
        <span class="condition action-hint">
          <img
            [src]="'./assets/images/' + (settingsManager.settings.fhStyle ? 'fh/' : '') +  'action/hint/' + actionHint.type + '.svg'" />
          <span class="value" [ngClass]="{'retaliate' : actionHint.type == 'retaliate'}">{{actionHint.value}}</span>
          @if (actionHint.range) {
          <span class="range">
            <img [src]="'./assets/images/' + (settingsManager.settings.fhStyle ? 'fh/' : '') +  'action/range.svg'" />
            <span class="value">{{actionHint.range}}</span>
          </span>
          }
        </span>
      </span>
      }
    </div>
    }


    <div class="markers">
      @if (marker) {
      <span class="placeholder placeholder-marker" ghs-pointer-input (doubleClick)="removeMarker()"
        [ghs-label]="'%game.mapMarker.' + marker + '%'"></span>
      }
      @for (marker of entity.markers; track marker) {
      <span class="marker" ghs-pointer-input (doubleClick)="removeCharacterMarker(marker)">
        <img [src]="gameManager.characterManager.characterIcon(marker)" />
      </span>
      }
      @for (marker of specialActionsMarker; track marker) {
      <span class="special-action-marker"
        [ghs-label]="'%data.characterToken.' + figure.name + '.' + specialActionsMarker + '%'"></span>
      }
    </div>

    <ghs-highlight-conditions [entity]="entity" [figure]="figure"></ghs-highlight-conditions>

    @if (!specialActionsMarker.length || specialActionsMarker.indexOf('mode') == -1) {
    <div class="conditions">
      @for (entityCondition of activeConditions | trackUUID; track entityCondition._trackUUID; let index = $index)
      {
      <span class="condition-container"
        [ngClass]="{'center' : (gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).summon == SummonState.false || gameManager.isSummon(entity) || gameManager.isObjectiveEntity(entity)) && ((activeConditions).length % 2) == 1 && (activeConditions).length == index + 1, 'expired' : entityCondition.expired, 'fh': settingsManager.settings.fhStyle}">
        <span class="condition" ghs-pointer-input (doubleClick)="removeCondition(entityCondition)">
          <img
            [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + entityCondition.name + '.svg'"
            [style.z-index]="index * 10 + entityCondition.value" />
          @if (entityCondition.types.indexOf(ConditionType.stack) != -1) {
          @for (i of [] | ghsRange:(entityCondition.value - 1); track i) {
          <img class="stack" [style.z-index]="index * 10 + entityCondition.value - i - 1"
            [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + entityCondition.name + '.svg'" />
          }
          }
          @if (entityCondition.types.indexOf(ConditionType.value) != -1 &&
          entityCondition.types.indexOf(ConditionType.stack) == -1) {
          <span class="value" [style.z-index]="index * 10 + entityCondition.value +1">{{entityCondition.value}}</span>
          }
          @if (entity.immunities.indexOf(entityCondition.name) != -1) {
          <span class="condition immunity condition-overlay"
            [style.z-index]="index * 10 + entityCondition.value + 2"></span>
          }
          @if (entityCondition.permanent) {
          <span class="condition permanent condition-overlay"
            [style.z-index]="index * 10 + entityCondition.value + 3"></span>
          }
        </span>
      </span>
      }
      @if (gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).summon != SummonState.false) {
      <span class="summon-container" [ngClass]="{'center' : (entity.entityConditions.length % 2) == 0}">
        <span class="summon"
          [ngClass]="{'active' : gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).summon == SummonState.true, 'new' : gameManager.isMonsterEntity(entity) && gameManager.toMonsterEntity(entity).summon == SummonState.new}">
          <img src="./assets/images/summons/{{ gameManager.toMonster(figure).summonColor }}.png">
        </span>
      </span>
      }
    </div>
    }

    <span class="value-overlay" [value-sign]="health" [hideEmpty]="true" [reverse]="settingsManager.settings.damageHP"
      [invert]="!!objectiveData && objectiveData.trackDamage" [container]="true"></span>
    <ghs-healthbar [entity]="entity" [diff]="health"></ghs-healthbar>
    <ghs-entity-index-key [entity]="entity"></ghs-entity-index-key>
  </div>

  <ghs-pointer-input class="drag-hp" (dragMove)="dragHpMove($event)" (dragEnd)="dragHpEnd($event)"
    (dragCancel)="dragHpCancel($event)" (singleClick)="openEntityMenu($event)" (doubleClick)="doubleClick($event)"
    [relative]="true" [screenWidth]="true" [fastShift]="true">
  </ghs-pointer-input>
</div>